(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-b2c-related"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('st-b2c-related'))customElements.define('st-b2c-related',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.rail=this.querySelector('.st-b2c-related__rail');this.toggle=this.querySelector('[data-rec-toggle]');this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches||Boolean(window.Shopify?.designMode);this.hover=false;this.focused=false;this.touching=false;this.visible=false;
 this.querySelector('[data-rec-prev]').addEventListener('click',()=>{this.paused=true;this.move(-1);this.schedule();},{signal});this.querySelector('[data-rec-next]').addEventListener('click',()=>{this.paused=true;this.move(1);this.schedule();},{signal});this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.schedule();},{signal});
 this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule();}},{signal});this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule();},{signal});this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();}),{signal});
 this.rail.addEventListener('pointerdown',()=>{this.touching=true;this.paused=true;this.schedule();},{signal});window.addEventListener('pointerup',()=>{this.touching=false;this.schedule();},{signal});this.rail.addEventListener('pointercancel',()=>{this.touching=false;this.schedule();},{signal});this.rail.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.paused=true;this.move(e.key==='ArrowLeft'?-1:1);this.schedule();}},{signal});
 this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.schedule();},{signal});document.addEventListener('visibilitychange',()=>this.schedule(),{signal});this.io=new IntersectionObserver(es=>{this.visible=es[0].isIntersecting;this.schedule();},{threshold:.1});this.io.observe(this);this.ro=new ResizeObserver(()=>this.schedule());this.ro.observe(this.rail);this.schedule();
 }
 move(direction){const first=this.rail.querySelector('article'),step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(this.rail).gap),max=this.rail.scrollWidth-this.rail.clientWidth,atEnd=this.rail.scrollLeft>=max-2,atStart=this.rail.scrollLeft<=2;const left=direction>0?(atEnd?0:Math.min(max,this.rail.scrollLeft+step)):(atStart?max:Math.max(0,this.rail.scrollLeft-step));this.rail.scrollTo({left,behavior:this.motion.matches?'instant':'smooth'});}
 schedule(){clearTimeout(this.timer);const stopped=this.paused||this.motion.matches;this.toggle.setAttribute('aria-label',stopped?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel);this.toggle.querySelector('span').textContent=stopped?'▷':'Ⅱ';if(!stopped&&!this.hover&&!this.touching&&(!this.focused||document.activeElement===this.toggle)&&this.visible&&!document.hidden&&this.rail.scrollWidth>this.rail.clientWidth+2)this.timer=setTimeout(()=>{this.move(1);this.schedule();},Number(this.dataset.interval)||4500);}
 disconnectedCallback(){clearTimeout(this.timer);this.io?.disconnect();this.ro?.disconnect();this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-category-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-category-gallery')) {
  customElements.define('st-category-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.cards = [...this.querySelectorAll('.st-category__card')];
      this.buttons = [...this.querySelectorAll('.st-category__select')];
      this.toggle = this.querySelector('.st-category__playback');
      this.stage = this.querySelector('.st-category__stage');
      this.current = this.querySelector('[data-category-current]');
      if (!this.cards.length) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.active = 0;
      this.paused = this.dataset.autoplay === 'false' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.visible = false;
      this.classList.add('is-ready');
      this.cards.forEach((card, i) => {
        card.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.select(i); this.schedule(); }
        }, {signal});
        card.addEventListener('focusin', () => { this.paused = true; this.select(i); }, {signal});
      });
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.buttons.forEach((button, i) => {
        button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.select(i); } }, {signal});
        button.addEventListener('click', () => { this.paused = true; this.select(i); }, {signal});
        button.addEventListener('focusin', () => { this.paused = true; this.select(i); }, {signal});
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : (i + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1) + this.cards.length) % this.cards.length;
          this.buttons[next].focus();
        }, {signal});
      });
      this.querySelector('[data-category-prev]')?.addEventListener('click', () => this.step(-1), {signal});
      this.querySelector('[data-category-next]')?.addEventListener('click', () => this.step(1), {signal});
      this.stage.addEventListener('pointerdown', event => {
        if (!this.mobile.matches || event.isPrimary === false || event.button > 0) return;
        this.gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,horizontal:false};
        clearTimeout(this.timer);
      }, {signal});
      this.stage.addEventListener('pointermove', event => {
        const g=this.gesture;
        if (!g || event.pointerId!==g.id) return;
        const dx=event.clientX-g.x,dy=event.clientY-g.y;
        if (!g.horizontal && Math.abs(dy)>Math.abs(dx)+8) {this.gesture=null;this.schedule();return;}
        if (Math.abs(dx)>12 && Math.abs(dx)>Math.abs(dy)*1.1) {
          g.horizontal=true;
          this.suppressClickUntil=performance.now()+700;
          if(event.cancelable)event.preventDefault();
          if(!this.stage.hasPointerCapture(event.pointerId))this.stage.setPointerCapture(event.pointerId);
        }
      }, {signal,passive:false});
      const finishSwipe = event => {
        const g=this.gesture;
        if(!g || event.pointerId!==g.id)return;
        this.gesture=null;
        if(g.horizontal)this.suppressClickUntil=performance.now()+700;
        if(this.stage.hasPointerCapture(g.id))this.stage.releasePointerCapture(g.id);
        if(event.type==='pointerup' && g.horizontal && Math.abs(event.clientX-g.x)>=40) this.step(event.clientX<g.x?1:-1);
        else this.schedule();
      };
      this.stage.addEventListener('pointerup',finishSwipe,{signal});
      this.stage.addEventListener('pointercancel',finishSwipe,{signal});
      this.stage.addEventListener('lostpointercapture',event=>{if(event.target===this.stage)finishSwipe(event);},{signal});
      this.stage.addEventListener('click', event => {
        if(performance.now()<(this.suppressClickUntil||0)){event.preventDefault();event.stopPropagation();}
      }, {signal,capture:true});
      this.stage.addEventListener('dragstart',event=>{if(this.mobile.matches)event.preventDefault();},{signal});
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, {signal});
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, {signal});
      this.mobile.addEventListener('change', () => this.select(this.active), {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.addEventListener('shopify:block:select', event => {
        const i = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (i >= 0) { this.paused = true; this.select(i); }
      }, {signal});
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold:.25});
      this.observer.observe(this);
      this.select(0);
    }
    step(direction) { this.paused=true;this.select((this.active+direction+this.cards.length)%this.cards.length); }
    select(i) {
      this.active = i;
      if(this.current)this.current.textContent=String(i+1).padStart(2,'0');
      this.cards.forEach((card, j) => {
        card.classList.toggle('is-active', j === i);
        const hidden = this.mobile.matches && j !== i;
        card.inert = hidden;
        if (hidden) card.setAttribute('aria-hidden','true'); else card.removeAttribute('aria-hidden');
      });
      this.buttons.forEach((button, j) => button.setAttribute('aria-pressed', String(j === i)));
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.motion.matches;
      this.toggle.querySelector('.st-category__playback-label').textContent = stopped ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.querySelector('.st-category__playback-icon').textContent = stopped ? '▷' : 'Ⅱ';
      if (!stopped && !this.hovered && !this.gesture && this.visible && !document.hidden) this.timer = setTimeout(() => this.select((this.active + 1) % this.cards.length), Number(this.dataset.interval) || 5500);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-commercial-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const slideButton = event.target.closest('[data-stc-slide]');
  if (slideButton) {
    const rail = document.getElementById(slideButton.getAttribute('aria-controls'));
    const card = rail && rail.querySelector('.stc-scene');
    if (card) { const gap = parseFloat(getComputedStyle(rail).columnGap) || 0; rail.scrollBy({left: Number(slideButton.dataset.stcSlide) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }
    return;
  }
  const modelLink = event.target.closest('[data-stc-model]');
  if (modelLink && modelLink.getAttribute('href') === '#rfq-form') {
    const modelField = document.querySelector('#rfq-form [name="contact[Interested Model]"]');
    if (modelField) { modelField.value = modelLink.dataset.stcModel; modelField.dispatchEvent(new Event('change', { bubbles: true })); }
    return;
  }
  const link = event.target.closest('[data-stc-context]');
  if (!link || link.getAttribute('href') !== '#rfq-form') return;
  const form = document.querySelector('#rfq-form form');
  if (!form) return;
  let context = form.querySelector('[name="contact[Application interest]"]');
  if (!context) {
    context = document.createElement('input');
    context.type = 'hidden';
    context.name = 'contact[Application interest]';
    form.appendChild(context);
  }
  context.value = link.dataset.stcContext;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('st-review-carousel')){
 customElements.define('st-review-carousel',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.track=this.querySelector('.st-reviews__track');this.cards=[...this.querySelectorAll('.st-reviews__card')];
   this.toggle=this.querySelector('[data-review-toggle]');this.status=this.querySelector('[data-review-status]');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches||Boolean(window.Shopify?.designMode);this.visible=false;this.hover=false;this.focused=false;this.index=0;
   this.querySelector('[data-review-next]')?.addEventListener('click',()=>{this.paused=true;this.go(this.index+1);},{signal});
   this.querySelector('[data-review-prev]')?.addEventListener('click',()=>{this.paused=true;this.go(this.index-1);},{signal});
   this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.schedule();},{signal});
   this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule();}},{signal});
   this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule();},{signal});
   this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
   this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});},{signal});
   this.track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.paused=true;this.go(this.index+(e.key==='ArrowLeft'?-1:1));}},{signal});
   this.track.addEventListener('scroll',()=>{this.index=this.nearest();this.update();},{signal,passive:true});
   this.track.addEventListener('mousedown',e=>{if(e.button!==0)return;e.preventDefault();this.down=true;this.dragged=false;this.startX=e.clientX;this.startScroll=this.track.scrollLeft;this.track.classList.add('is-dragging');this.schedule();},{signal});
   document.addEventListener('mousemove',e=>{if(!this.down)return;this.dragged=this.dragged||Math.abs(e.clientX-this.startX)>5;this.track.scrollLeft=this.startScroll-(e.clientX-this.startX);},{signal});
   document.addEventListener('mouseup',()=>{if(!this.down)return;this.down=false;this.track.classList.remove('is-dragging');this.index=this.nearest();this.schedule();},{signal});
   this.track.addEventListener('click',e=>{if(this.dragged){e.preventDefault();e.stopPropagation();this.dragged=false;}},{signal,capture:true});
   this.track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
   this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(card=>card.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.go(Math.min(i,this.positions().length-1),true);}},{signal});
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.schedule();},{signal});
   document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
   this.ro=new ResizeObserver(()=>{this.go(this.index,true);});this.ro.observe(this.track);
   this.io=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.25});this.io.observe(this);
   this.update();
  }
  positions(){const base=this.cards[0]?.offsetLeft||0;const max=this.track.scrollWidth-this.track.clientWidth;return [...new Set(this.cards.map(card=>Math.max(0,Math.min(max,card.offsetLeft-base))))];}
  nearest(){const points=this.positions();return points.reduce((best,x,i)=>Math.abs(x-this.track.scrollLeft)<Math.abs(points[best]-this.track.scrollLeft)?i:best,0);}
  go(index,immediate=false){const points=this.positions();if(!points.length)return;this.index=(index+points.length)%points.length;this.track.scrollTo({left:points[this.index],behavior:immediate||this.motion.matches?'instant':'smooth'});this.update();this.schedule();}
  update(){const points=this.positions();if(this.status)this.status.textContent=(this.index+1)+' / '+points.length;}
  schedule(){clearTimeout(this.timer);const stopped=this.paused||this.motion.matches;this.toggle?.setAttribute('aria-label',stopped?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel);if(this.toggle)this.toggle.querySelector('span').textContent=stopped?'▷':'Ⅱ';if(!stopped&&!this.hover&&!this.focused&&!this.down&&this.visible&&!document.hidden&&this.positions().length>1)this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.interval)||6000);}
  disconnectedCallback(){clearTimeout(this.timer);this.ro?.disconnect();this.io?.disconnect();this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-pdp-sequence"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('st-pdp-sequence'))customElements.define('st-pdp-sequence',class extends HTMLElement{
 connectedCallback(){document.body.classList.add('st-has-pdp-sticky');this.addButton=this.querySelector('[data-st-pdp-add]');this.addButton?.addEventListener('click',()=>{const button=document.querySelector('product-info product-form button[name="add"]:not([disabled]),form[action*="/cart/add"] button[name="add"]:not([disabled])');button?.click();});}
 disconnectedCallback(){document.body.classList.remove('st-has-pdp-sticky');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-product-pairings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-product-pairings')) {
  const feedCache = new Map();
  customElements.define('st-product-pairings', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const observe = () => {
        if (!this.isConnected) return;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, {rootMargin: '600px 0px'});
        this.observer.observe(this);
      };
      if (document.readyState === 'complete') observe();
      else window.addEventListener('load', observe, {once: true});
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    eligible(card, automatic) {
      const item = card.dataset;
      if (item.productId === this.dataset.productId) return false;
      const oil = this.dataset.oil === 'true';
      const itemOil = item.oil === 'true';
      if (this.dataset.intent === 'related') {
        return oil === itemOil && (oil || item.collections.split('|').includes(this.dataset.collection));
      }
      if (oil === itemOil || item.stock !== 'true') return false;
      const sourceGroups = (this.dataset.groups || '').split('|').filter(Boolean);
      const candidateGroups = (item.groups || '').split('|').filter(Boolean);
      const waterBased = [...sourceGroups, ...candidateGroups].some(group => group.startsWith('water_based'));
      if (waterBased && !sourceGroups.some(group => candidateGroups.includes(group))) return false;
      const volume = Number(oil ? this.dataset.volume : item.volume);
      const carPair = oil ? item.car === 'true' : this.dataset.car === 'true';
      if (carPair && !(volume > 0 && volume <= 100)) return false;
      if (automatic) {
        if (carPair) return sourceGroups.some(group => candidateGroups.includes(group));
        const groups = (this.dataset.groups || '').split('|').filter(Boolean);
        return (item.groups || '').split('|').some(group => group && groups.includes(group));
      }
      return item.mates.split('|').includes(this.dataset.productId);
    }
    async load() {
      const manual = [...this.querySelector('.st-pairings__manual').content.querySelectorAll('.st-pairings__card')];
      let automatic = [];
      const url = this.dataset.url;
      if (url) {
        try {
          if (!feedCache.has(url)) feedCache.set(url, fetch(url).then(response => {
            if (!response.ok) throw new Error('Feed unavailable');
            return response.text();
          }));
          const doc = new DOMParser().parseFromString(await feedCache.get(url), 'text/html');
          automatic = [...(doc.querySelector('template[data-st-pairing-feed]')?.content.querySelectorAll('.st-pairings__card') || [])];
        } catch { feedCache.delete(url); }
      }
      if (!this.isConnected) return;
      const selected = [], seen = new Set();
      for (const [cards, isAutomatic] of [[automatic, true], [manual, false]]) {
        for (const card of cards) {
          if (seen.has(card.dataset.productId) || !this.eligible(card, isAutomatic)) continue;
          selected.push(card.cloneNode(true));
          seen.add(card.dataset.productId);
          if (selected.length >= Number(this.dataset.limit)) break;
        }
        if (selected.length >= Number(this.dataset.limit)) break;
      }
      if (!selected.length) { this.remove(); return; }
      const shell = this.querySelector('.st-pairings__shell').content.cloneNode(true);
      const rail = shell.querySelector('.st-pairings__rail');
      rail.style.setProperty('--pairing-count', selected.length);
      rail.append(...selected);
      this.replaceChildren(shell);
      this.dataset.loaded = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-scent-studio-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) { target.classList.remove('st-studio__pending'); observer.unobserve(target); }
      });
    }, { threshold: 0.05 });
    document.querySelectorAll('.st-studio [data-studio-reveal]').forEach((element) => {
      if (element.dataset.studioObserved) return;
      element.dataset.studioObserved = 'true';
      if (element.getBoundingClientRect().top > window.innerHeight) element.classList.add('st-studio__pending');
      observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-spaces-inspiration"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-spaces-gallery')) {
 customElements.define('st-spaces-gallery', class extends HTMLElement {
  connectedCallback() {
   if(this.abort)return;
   this.abort=new AbortController();const signal=this.abort.signal;
   this.viewport=this.querySelector('.st-spaces__viewport');this.track=this.querySelector('.st-spaces__track');
   this.cards=[...this.querySelectorAll('.st-spaces__card')];this.images=this.cards.map(e=>e.querySelector('.st-spaces__image'));
   this.cursor=this.querySelector('.st-spaces__cursor');this.toggle=this.querySelector('[data-space-toggle]');this.count=this.cards.length/3;
   if(!this.count)return;
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.paused=this.dataset.autoplay!=='true'||this.motion.matches||Boolean(window.Shopify?.designMode);
   this.position=0;this.target=0;this.velocity=0;this.bend=0;this.resumeAt=0;
   this.down=false;this.hover=false;this.focused=false;this.visible=false;
   this.pointerX=0;this.pointerY=0;this.cursorX=0;this.cursorY=0;
   this.classList.add('is-ready');
   this.resize=()=>{this.width=this.viewport.clientWidth;this.cardWidth=this.width<750?Math.min(this.width*.76,340):Math.min(360,Math.max(260,this.width*.245));this.step=this.cardWidth+(this.width<750?16:22);this.cards.forEach(e=>e.style.width=this.cardWidth+'px');this.draw();};
   this.ro=new ResizeObserver(this.resize);this.ro.observe(this.viewport);
   this.cardRO=new ResizeObserver(()=>{this.track.style.height=Math.ceil(Math.max(this.width<750?400:500,...this.cards.map(e=>e.offsetHeight)))+'px';});this.cards.forEach(e=>this.cardRO.observe(e));
   this.io=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.wake();else this.stopFrame();},{threshold:.05});this.io.observe(this);
   const point=e=>{const r=this.viewport.getBoundingClientRect();this.pointerX=e.clientX-r.left;this.pointerY=e.clientY-r.top;};
   const release=e=>{
    if(!this.down)return;
    this.down=false;if(performance.now()-this.lastTime>120||this.motion.matches)this.velocity=0;
    this.viewport.classList.remove('is-dragging');
    if(this.pointerId!==undefined&&this.viewport.hasPointerCapture(this.pointerId))this.viewport.releasePointerCapture(this.pointerId);
    this.pointerId=undefined;this.deferAuto();this.wake();
   };
   this.viewport.addEventListener('pointerdown',e=>{
    if(e.isPrimary===false||e.button>0||this.down)return;
    if(e.pointerType==='mouse')e.preventDefault();
    this.down=true;this.pointerId=e.pointerId;this.input=e.pointerType||'mouse';this.startX=e.clientX;this.startY=e.clientY;this.lastX=e.clientX;this.lastTime=performance.now();this.velocity=0;this.target=this.position;this.dragging=false;
    point(e);this.viewport.classList.add('is-dragging');
    try{this.viewport.setPointerCapture(e.pointerId);}catch(error){/* A detached editor preview can end the pointer before capture. */}
    this.wake();
   },{signal});
   this.viewport.addEventListener('pointermove',e=>{
    point(e);if(e.pointerType==='mouse')this.hover=true;
    if(!this.down){this.wake();return;}
    if(e.pointerId!==this.pointerId)return;
    if(this.input==='touch'&&!this.dragging&&Math.abs(e.clientY-this.startY)>Math.abs(e.clientX-this.startX)+8){this.velocity=0;release(e);return;}
    const now=performance.now(),dx=e.clientX-this.lastX;
    this.dragging=this.dragging||Math.abs(e.clientX-this.startX)>3;
    if(this.dragging&&e.cancelable)e.preventDefault();
    this.target+=dx;this.position=this.target;
    const speed=Math.max(-50,Math.min(50,dx/Math.max(8,now-this.lastTime)*16.67));
    this.velocity=this.motion.matches?0:this.velocity*.35+speed*.65;
    this.bend=this.motion.matches?0:Math.max(-32,Math.min(32,speed*.8));
    this.lastX=e.clientX;this.lastTime=now;this.draw();this.wake();
   },{signal,passive:false});
   this.viewport.addEventListener('pointerup',release,{signal});
   this.viewport.addEventListener('pointercancel',e=>{this.velocity=0;release(e);},{signal});
   this.viewport.addEventListener('lostpointercapture',release,{signal});
   this.viewport.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.wake();}},{signal});
   this.viewport.addEventListener('pointerleave',()=>{this.hover=false;this.wake();},{signal});
   this.viewport.addEventListener('dragstart',e=>e.preventDefault(),{signal});
   this.viewport.addEventListener('mousedown',e=>e.preventDefault(),{signal});
   window.addEventListener('blur',()=>{this.velocity=0;release();},{signal});
   this.addEventListener('focusin',()=>{this.focused=true;this.wake();},{signal});
   this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.wake();});},{signal});
   this.querySelector('[data-space-prev]').addEventListener('click',()=>this.move(1),{signal});
   this.querySelector('[data-space-next]').addEventListener('click',()=>this.move(-1),{signal});
   this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updatePlayback();this.wake();},{signal});
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.move(e.key==='ArrowLeft'?1:-1);}},{signal});
   this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.shopifyEditorBlock&&JSON.parse(c.dataset.shopifyEditorBlock).id===e.detail.blockId);if(i>=0){this.paused=true;this.velocity=0;this.target=-(i-this.count)*this.step;this.updatePlayback();if(this.motion.matches){this.position=this.target;this.draw();}else this.wake();}},{signal});
   this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.velocity=0;this.bend=0;this.position=this.target;this.updatePlayback();this.draw();this.wake();},{signal});
   document.addEventListener('visibilitychange',()=>{if(document.hidden){this.velocity=0;release();this.stopFrame();}else this.wake();},{signal});
   window.addEventListener('scroll',()=>{if(!this.frame)this.wake();},{signal,passive:true});
   this.resize();this.updatePlayback();this.wake();
  }
  updatePlayback(){const stopped=this.paused||this.motion.matches;this.toggle.setAttribute('aria-label',stopped?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel);this.toggle.querySelector('span').textContent=stopped?'▷':'Ⅱ';this.toggle.disabled=this.motion.matches;}
  deferAuto(){this.resumeAt=performance.now()+2200;clearTimeout(this.resumeTimer);this.resumeTimer=setTimeout(()=>this.wake(),2250);}
  canAuto(time){return !this.paused&&!this.motion.matches&&!this.down&&!this.hover&&(!this.focused||document.activeElement===this.toggle)&&time>=this.resumeAt&&Math.abs(this.velocity)<.1;}
  move(direction){this.velocity=0;this.target+=direction*this.step;this.deferAuto();if(this.motion.matches){this.position=this.target;this.draw();}else this.wake();}
  draw(){
   if(!this.step)return;
   const total=this.cards.length*this.step,center=(this.width-this.cardWidth)/2,reduced=this.motion.matches||this.dataset.curve==='false';
   const amount=Number(this.dataset.curveAmount||58),curve=this.width<750?amount*.38:amount;
   this.cards.forEach((card,i)=>{
    let x=(i-this.count)*this.step+this.position;x=((x+total/2)%total+total)%total-total/2;
    const left=center+x,d=Math.max(-1.6,Math.min(1.6,x/(this.width*.5)));
    card.style.transform='translate3d('+left.toFixed(2)+'px,0,0)';this.images[i].style.transform='perspective(1100px) rotateY('+(reduced?0:d*21+this.bend*.28).toFixed(2)+'deg)';
    if(reduced)this.images[i].style.clipPath='none';else{
     const top=[],bottom=[];for(let j=0;j<=12;j++){const u=Math.max(-1.15,Math.min(1.15,(left+this.cardWidth*j/12-this.width/2-this.bend*3)/(this.width*.52))),inset=curve*Math.max(0,1-u*u);top.push((j/12*100).toFixed(2)+'% '+inset.toFixed(2)+'px');bottom.unshift((j/12*100).toFixed(2)+'% calc(100% - '+inset.toFixed(2)+'px)');}
     this.images[i].style.clipPath='polygon('+top.concat(bottom).join(',')+')';
    }
   });
  }
  stopFrame(){cancelAnimationFrame(this.frame);this.frame=null;this.lastFrame=null;}
  inViewport(){const r=this.getBoundingClientRect();return r.width>0&&r.bottom>0&&r.top<(document.documentElement.clientHeight||innerHeight);}
  wake(){this.visible=this.inViewport();this.dataset.motionState=document.hidden?'hidden':!this.visible?'outside':this.motion.matches?'reduced-motion':'ready';if(!this.frame&&this.visible&&!document.hidden){this.lastFrame=null;this.frame=requestAnimationFrame(t=>this.tick(t));}}
  tick(time){
   this.dataset.motionState='running';this.frame=null;const dt=this.lastFrame?Math.min(32,time-this.lastFrame)/16.67:1;this.lastFrame=time;
   if(!this.down&&Math.abs(this.velocity)>.05){this.target+=this.velocity*dt;this.velocity*=Math.pow(.945,dt);}else if(!this.down)this.velocity=0;
   const auto=this.canAuto(time);if(auto)this.target-=Number(this.dataset.speed||24)/60*dt;
   const delta=this.target-this.position;this.position+=delta*(1-Math.pow(.78,dt));
   const bendTarget=this.motion.matches?0:Math.max(-32,Math.min(32,delta*.14));this.bend+=(bendTarget-this.bend)*.2;
   if(Math.abs(delta)<.03)this.position=this.target;
   const total=this.cards.length*this.step;if(Math.abs(this.position)>total*10){const offset=Math.trunc(this.position/total)*total;this.position-=offset;this.target-=offset;}
   this.draw();this.cursorX+=(this.pointerX-this.cursorX)*.28;this.cursorY+=(this.pointerY-this.cursorY)*.28;
   this.cursor.style.opacity=this.hover&&!this.motion.matches?'1':'0';this.cursor.style.transform='translate3d('+(this.cursorX-26)+'px,'+(this.cursorY-26)+'px,0) scale('+(this.down?.78:1)+')';
   const moving=auto||this.down||Math.abs(this.target-this.position)>.03||Math.abs(this.velocity)>.05||Math.abs(this.bend)>.03||(this.hover&&(Math.abs(this.pointerX-this.cursorX)>1||Math.abs(this.pointerY-this.cursorY)>1));
   if(moving&&this.visible&&!document.hidden)this.frame=requestAnimationFrame(t=>this.tick(t));else this.lastFrame=null;
  }
  disconnectedCallback(){this.stopFrame();clearTimeout(this.resumeTimer);this.ro?.disconnect();this.cardRO?.disconnect();this.io?.disconnect();this.abort?.abort();this.abort=null;}
 });
}


  } catch(e) { console.error(e); }
})();
})();
